import { isCustomEvents } from "../../../helpers/utils";
import { completeRsc, getDiscipline } from "helpers/rsc";

const isLink = ({ target }) => {
    let counter = 0
    let node = target
    //If the target node doesn't have ref, tries to find it in the first 5 parents
    while (!node?.href && counter < MAX_DEPTH) {
        if (node?.className?.includes && (node?.className?.includes('clickable-row') || node?.className?.includes('itemDiscipline'))) return DESTINATION_TYPE.PAGE
        node = node?.parentNode
        counter++
    }
    return node?.href ? true : false
}

export const handleLinkClicked = (e, getEventUnits, paramsURL) => {
    //console.log(e?.target)

    const payLoadCalculator = getPayLoadCalculator({ target: e?.target })

    const { payload } = payLoadCalculator({ target: e?.target, getEventUnits: getEventUnits, paramsURL: paramsURL })

    if (isLink({ target: e?.target })) dispatchOnLinkClickedEvent({ payload: payload })
}

const getPayLoadCalculator = ({ target }) => {

    if (isSubnavigation({ target: target })) {
        return subNavigationCalculator

    } else if (isTab({ target: target })) {
        return tabCalculator

    } else if (isRibbonSection({ target: target })) {
        return ribbonCalculator

    } else if (isEventSection({ target: target })) {
        return eventCalculator

    } else if (isSubmenuDisciplineList({ target: target })) {
        return subDisciplineListCalculator

    } else if (isSubNavigationDropDownElement({ target: target })) {
        return subNavigationDropDownElementCalculator

    } else {
        return defaultCalculator
    }

}

const dispatchOnLinkClickedEvent = ({ payload }) => {

    if (!payload || !payload.module) return;

    // filter undefined values
    const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => value !== undefined)
    )

    if (isCustomEvents() || process.env.REACT_APP_DEVELOPMENT === 'DEV' || process.env.REACT_APP_DEVELOPMENT === 'MT') {
        const event = new CustomEvent('OnLinkClicked', { detail: filteredPayload });
        window.dispatchEvent(event)
    }
}

const subNavigationCalculator = ({ target, getEventUnits, paramsURL}) => {

    const { module, moduleElement } = getSubnavigationModuleElement({ target: target })

    const payload = {
        module: module,
        moduleElement: moduleElement,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL }),
        labelTag: getLabelTag({ target: target }),
        destinationType: getDestinationType({ target: target }),
        destination: target?.href
    }

    return ({ payload: payload })
}

const tabCalculator = ({ target, getEventUnits, paramsURL }) => {

    const payload = {
        module: MODULE.RESULT_TAB,
        moduleElement: undefined,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL }),
        labelTag: getLabelTag({ target: target }),
        destinationType: getDestinationType({ target: target }),
        destination: target?.href
    }

    return ({ payload: payload })
}

const getSubnavigationModuleElement = ({ target }) => {
    const parent = target?.parentElement
    let module = MODULE.SUB_NAVIGATION
    let moduleElement = undefined

    if (isInto(parent?.id, 'OCSMenuReports')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.REPORTS

    } else if (isInto(parent?.id, 'OCSMenuRanking,OCSMenuEntries,OCSMenuRecords')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.RESULTS

    } else if (isInto(parent?.id, 'OCSMenuTodayMatches,OCSMenuHearingSchedule,OCSMenuCompetitionStatus,OCSMenuSchedule')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.LIVE

    } else if (equals(parent?.id, 'OCSMenuBrackets')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.BRACKET

    } else if (equals(parent?.id, 'OCSMenuGroups')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.GROUPS

    } else if (equals(parent?.id, 'OCSMenuEvents')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.EVENTS

    } else if (isInto(parent?.id, 'OCSMenuMedalStandings,OCSMenuMedallists,OCSMenuMultiMedallists')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.MEDALS_RANKING

    } else if (isInto(parent?.id, 'OCSMenuTeams,OCSMenuCoaches,OCSMenuOfficials,OCSMenuHorses,OCSMenuNocList,OCSMenuEntriesDiscipline,OCSMenuAthletes')) {
        moduleElement = MODULE_ELEMENT.SUB_NAVIGATION.PARTICIPANTS

    } else if (isInto(parent?.id, 'OCSMenuScheduleByNoc,OCSMenuEntriesByNoc,OCSMenuMedallistByNoc,OCSMenuProfileByNoc,OCSMenuAthleteByNoc')) {
        moduleElement = undefined
    }

    return (
        {
            module: module,
            moduleElement: moduleElement
        }
    )
}

const getRibbonModuleElement = ({ target }) => {
    let module = MODULE.RIBBON
    const { isRBox, href } = isRibbonBox({ target: target })
    let moduleElement = isRBox ? MODULE_ELEMENT.RIBBON.EVENT_UNIT : MODULE_ELEMENT.RIBBON.PHASE_TAB
    return (
        {
            module: module,
            moduleElement: moduleElement,
            href: href
        }
    )
}

const ribbonCalculator = ({ target, getEventUnits, paramsURL }) => {

    const { module, moduleElement, href } = getRibbonModuleElement({ target: target })
    const destinationType = moduleElement === MODULE_ELEMENT.RIBBON.EVENT_UNIT ? DESTINATION_TYPE.PAGE : DESTINATION_TYPE.OTHER

    const payload = {
        module: module,
        moduleElement: moduleElement,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL }),
        labelTag: getLabelTag({ target: target }),
        destinationType: destinationType,
        destination: href
    }

    return ({ payload: payload })

}

const eventCalculator = ({ target, getEventUnits, paramsURL}) => {
    //console.log('eventCalculator')
    const moduleElement = target?.className?.includes && target?.className?.includes('itemDiscipline') ? MODULE_ELEMENT.SELECTOR.DISCIPLINE : MODULE_ELEMENT.SELECTOR.EVENT

    const payload = {
        module: MODULE.SELECTOR,
        moduleElement: moduleElement,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL  }),
        labelTag: getLabelTag({ target: target }),
        destinationType: getDestinationType({ target: target }),
        destination: target?.href
    }

    return ({ payload: payload })

}

const subDisciplineListCalculator = ({ target, getEventUnits, paramsURL}) => {
    //console.log('subDisciplineListCalculator')

    const payload = {
        module: MODULE.SELECTOR,
        moduleElement: MODULE_ELEMENT.SELECTOR.DISCIPLINE_LIST,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL}),
        labelTag: getLabelTag({ target: target }),
        destinationType: DESTINATION_TYPE.OTHER,
        destination: target?.href
    }

    return ({ payload: payload })

}

const subNavigationDropDownElementCalculator = ({ target, getEventUnits, paramsURL}) => {
    //console.log('subNavigationDropDownElementCalculator')
    const payload = {
        module: MODULE.DROP_DOWN,
        moduleElement: undefined,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL }),
        labelTag: getLabelTag({ target: target }),
        destinationType: getDestinationType({ target: target }),
        destination: target?.href
    }

    return ({ payload: payload })
}

const defaultCalculator = ({ target, getEventUnits, paramsURL}) => {
    //console.log('defaultCalculator')
    const payload = {
        module: MODULE.RESULT_CONTENT,
        moduleElement: undefined,
        label: getLabelEnglish({ target: target, getEventUnits: getEventUnits, paramsURL: paramsURL}),
        labelTag: getLabelTag({ target: target }),
        destinationType: getDestinationType({ target: target }),
        destination: target?.href
    }

    return ({ payload: payload })
}


const MODULE = {
    SUB_NAVIGATION: 'subNavigation',
    RIBBON: 'eventRibbon',
    SELECTOR: 'eventsSelector',
    DROP_DOWN: 'subNavigationDropDownElement',
    RESULT_TAB: 'resultsTab',
    RESULT_CONTENT: 'resultsContent'
}



const MODULE_ELEMENT = {
    SUB_NAVIGATION: {
        EVENTS: 'events',
        RESULTS: 'results',
        LIVE: 'live', // for today schedule and competition status
        GROUPS: 'groups',
        BRACKET: 'bracket', // for draw too
        STANDINGS: 'standings', // (e.g. “Decathlon Summary”, “Modern Pentathlon Points”, “Overall results” etc.)
        MEDALS_RANKING: 'medalsRanking',
        REPORTS: 'reports',
        PARTICIPANTS: 'participants'
    },
    RIBBON: {
        PHASE_TAB: 'phaseTab',
        EVENT_UNIT: 'eventUnit'
    },
    SELECTOR: {
        EVENT: 'event',
        DISCIPLINE_LIST: 'disciplineList', // '<sports' link
        DISCIPLINE: 'discipline'
    }
}

const DESTINATION_TYPE = {
    PAGE: 'page',
    OTHER: 'other'

}

const MAX_DEPTH = 5


const equals = (id, b) => id?.toUpperCase() === b?.toUpperCase();

const isInto = (id, idsList) => id && idsList?.toUpperCase()?.includes(id?.toUpperCase())

const isSubnavigation = ({ target }) => {
    if (target?.role === 'tab') return false
    return target?.className?.includes && (target?.className?.includes('nav-link') || target?.className?.includes('dropdown-toggle'))
}

const isTab = ({ target }) => {
    return target?.role === 'tab'
}

const isRibbonSection = ({ target }) => {
    if (target?.className?.includes && target?.className?.includes('container-navigation-phase-units')) return true;
    let node = target?.parentNode;
    while (node) {
        if (node?.className?.includes && node?.className?.includes('container-navigation-phase-units')) {
            return true;
        }
        node = node?.parentNode;
    }
    return false;
}

const isRibbonBox = ({ target }) => {
    let href = target?.href;
    if (target?.className?.includes && target?.className?.includes('ribbon-element')) return { isRBox: true, href: href };
    let node = target?.parentNode;
    while (node) {
        href = !href ? target?.href : href
        if (target?.className?.includes && node?.className?.includes('ribbon-element')) {
            return { isRBox: true, href: href }
        }
        node = node?.parentNode;
    }
    return { isRBox: false, href: href }
}

const isEventSection = ({ target }) => {
    let node = target?.parentNode;
    while (node) {
        if (node?.id === 'OCSMenuEvents') {
            return true;
        }
        node = node?.parentNode;
    }
    return false;
}

const isSubmenuDisciplineList = ({ target }) => {
    if (target?.id === 'OcsSubmenuDisciplineList') return true
    let node = target?.parentNode;
    while (node) {
        if (node?.id === 'OcsSubmenuDisciplineList') {
            return true;
        }
        node = node?.parentNode;
    }
    return false;
}

const isSubNavigationDropDownElement = ({ target }) => {
    if (target?.id?.includes('OCSMenu')) return false
    let node = target?.parentNode;
    while (node) {
        if (!node?.id?.includes('OCSMenuEvents') && node?.id?.includes('OCSMenu')) {
            return true;
        }
        node = node?.parentNode;
    }
    return false;
}

const getDestinationType = ({ target }) => {
    let counter = 0
    let node = target
    //If the target node doesn't have ref, tries to find it in the first 5 parents
    while (!node?.href && counter < MAX_DEPTH) {
        if (node?.className?.includes && (node?.className?.includes('clickable-row') || node?.className?.includes('itemDiscipline'))) return DESTINATION_TYPE.PAGE
        node = node?.parentNode
        counter++
    }
    return !node?.href || (node?.href?.includes && node?.href?.includes('#')) ? DESTINATION_TYPE.OTHER : DESTINATION_TYPE.PAGE
}

const getLabelTag = ({ target }) => {
    const rsc = sessionStorage.getItem('RSC')
    let counter = 0
    let node = target
    //If the target node doesn't have dataSet, tries to find it in the first 5 parents
    while (!node?.dataset?.ocsEvent && counter < MAX_DEPTH) {
        counter++
        node = node?.parentNode
    }
    if (node?.dataset?.ocsEvent) return node?.dataset?.ocsEvent
    if (rsc) return rsc
    return undefined
}

const getLabelEnglish = ({ target, getEventUnits, paramsURL }) => {

    let counter = 0
    let node = target
    //If the target node doesn't have dataSet, tries to find it in the first 5 parents
    while (!node?.dataset?.ocsLabel && counter < MAX_DEPTH) {
        counter++
        node = node?.parentNode
    }
    if (node?.dataset?.ocsLabel) {
        return node?.dataset?.ocsLabel
    }

    const labelTag = getLabelTag({ target: target })
    const innerText = target?.innerText 
    if(labelTag) {
        const rsc = completeRsc(labelTag)
        paramsURL.mirs_discipline = getDiscipline(rsc)
        const eventUnits = getEventUnits(paramsURL)
        const data = eventUnits?.eventUnits?.find(eu => eu?.code === rsc)
        return data?.descriptionEng ||  data?.description || innerText
    }
 
    return innerText;
}